import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=4f270932&scoped=true"
import script from "./SiteBanner.vue?vue&type=script&lang=js"
export * from "./SiteBanner.vue?vue&type=script&lang=js"
import style0 from "./SiteBanner.vue?vue&type=style&index=0&id=4f270932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f270932",
  null
  
)

export default component.exports